import React, { useEffect, useState } from 'react'

export default function FooterLayout() {
    const [year, setYear] = useState('')
    useEffect(()=>{
        getFullYear()
    }, [])
    const getFullYear = ()=>{
        let dateObject = new Date();
        let currentYear = dateObject.getFullYear();
        setYear(currentYear)
    }
  return (
        <footer className="custom-footer footer mt-auto border-top">
            <div className="copyright bg-white">
              <p className='font-weight-bold text-dark'>
                Copyright &copy; <span id="copy-year">{year}</span> <span className='text-primary'>National Office For Technology Acquisition and Promotion</span>. All rights reserved.
              </p>
            </div>
          </footer>
  )
}
